export default "__VITE_ASSET__fd72b113__"